import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImageDownload = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12.5 9V15.5M12.5 15.5L15 13M12.5 15.5L10 13",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 6C5 4.34315 6.34315 3 8 3H14.5858C14.851 3 15.1054 3.10536 15.2929 3.29289L19.7071 7.70711C19.8946 7.89464 20 8.149 20 8.41421V18C20 19.6569 18.6569 21 17 21H8C6.34315 21 5 19.6569 5 18V6Z",
			stroke: "#8A94A6",
			strokeWidth: 1.6
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_5451_25250",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 5,
			y: 3,
			width: 15,
			height: 18,
			children: /* @__PURE__ */ _jsx("rect", {
				x: 5,
				y: 3,
				width: 15,
				height: 18,
				rx: 3,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_5451_25250)",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 15,
				y: -10,
				width: 15,
				height: 18,
				rx: 2,
				stroke: "#8A94A6",
				strokeWidth: 1.6
			})
		})
	]
});
const ForwardRef = forwardRef(SvgImageDownload);
export { ForwardRef as ReactComponent };
